import React from 'react';

const PDFEXPIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.188" height="20.471" viewBox="0 0 15.188 20.471">
      <g id="_x32_7_x2C__PDF_x2C__File_type_x2C__Adobe" transform="translate(-88.47 -53.191)">
        <g id="Group_16321" data-name="Group 16321" transform="translate(88.47 53.191)">
          <path id="Path_10427" data-name="Path 10427" d="M367.268,53.245l2.962,2.972-.011.011-2.926,0-.027-2.983Z" transform="translate(-355.054 -53.242)" fill="#f1f1f1" />
          <path
            id="Path_10428"
            data-name="Path 10428"
            d="M190.116,132.577a.731.731,0,0,1-.8.826.991.991,0,0,1-.185-.01v-1.544a1.11,1.11,0,0,1,.242-.021A.677.677,0,0,1,190.116,132.577Z"
            transform="translate(-185.927 -127.857)"
            fill="#f1f1f1"
          />
          <path
            id="Path_10429"
            data-name="Path 10429"
            d="M149.065,132.044c0,.242-.175.386-.458.386a.823.823,0,0,1-.179-.014v-.7a.92.92,0,0,1,.22-.021C148.915,131.7,149.065,131.827,149.065,132.044Z"
            transform="translate(-147.286 -127.735)"
            fill="#f1f1f1"
          />
          <path
            id="Path_10431"
            data-name="Path 10431"
            d="M267.737,243.128a7.186,7.186,0,0,1-.346,1.625,2.957,2.957,0,0,1-.364-1.446c0-.633.2-.806.364-.806S267.73,242.578,267.737,243.128Z"
            transform="translate(-259.89 -232.94)"
            fill="#dc1d00"
          />
          <path
            id="Path_10432"
            data-name="Path 10432"
            d="M317.329,342.361c0,.727-1.318.431-2.129-.341C315.2,342.02,317.329,341.634,317.329,342.361Z"
            transform="translate(-305.624 -327.342)"
            fill="#dc1d00"
          />
          <path
            id="Path_10433"
            data-name="Path 10433"
            d="M202.712,367.618c-.652-.39,1.369-1.593,1.734-1.631C204.446,365.987,203.395,368.027,202.712,367.618Z"
            transform="translate(-198.697 -350.172)"
            fill="#dc1d00"
          />
          <path
            id="Path_10434"
            data-name="Path 10434"
            d="M265.028,311.26a9.482,9.482,0,0,0,1.107,1.5,8.626,8.626,0,0,0-.936.192,5.05,5.05,0,0,0-.983.327l.269-.6C264.753,312.079,265.028,311.26,265.028,311.26Z"
            transform="translate(-257.216 -298.227)"
            fill="#dc1d00"
          />
          <path
            id="Path_10435"
            data-name="Path 10435"
            d="M140.838,56.195V73.662H125.65V54.889h9.245v.393H125.65V53.191h12.194l0,0,0,0,.028,3,2.944,0,.012-.011Z"
            transform="translate(-125.65 -53.191)"
            fill="#dc1d00"
          />
          <g id="Group_16320" data-name="Group 16320" transform="translate(3.105 8.804)">
            <path
              id="Path_10437"
              data-name="Path 10437"
              d="M229.25,124.723V124H227v3.776h.8V126.25h1.366v-.643H227.8v-.884Z"
              transform="translate(-219.769 -123.973)"
              fill="#fff"
            />
            <path
              id="Path_10438"
              data-name="Path 10438"
              d="M180.739,124.065a2.486,2.486,0,0,0-1.566-.4,7.914,7.914,0,0,0-1.173.079v3.713a8.1,8.1,0,0,0,.989.056,2.739,2.739,0,0,0,1.753-.488,1.92,1.92,0,0,0,.633-1.531A1.669,1.669,0,0,0,180.739,124.065Zm-1.593,2.776a2.767,2.767,0,0,1-.342-.017v-2.473a3.31,3.31,0,0,1,.433-.034,1.085,1.085,0,0,1,1.189,1.2A1.172,1.172,0,0,1,179.146,126.841Z"
              transform="translate(-174.706 -123.661)"
              fill="#fff"
            />
            <path
              id="Path_10439"
              data-name="Path 10439"
              d="M139.382,123.965a1.925,1.925,0,0,0-1.191-.3,7.314,7.314,0,0,0-1.191.079v3.725h.884v-1.347a2.408,2.408,0,0,0,.309.018,1.775,1.775,0,0,0,1.237-.4,1.211,1.211,0,0,0,.352-.9A1.1,1.1,0,0,0,139.382,123.965Zm-1.195,1.515a1.549,1.549,0,0,1-.3-.023v-1.116a1.792,1.792,0,0,1,.37-.033c.427,0,.668.207.668.555C138.922,125.249,138.641,125.48,138.187,125.48Z"
              transform="translate(-137 -123.662)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PDFEXPIcon;
